import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { EMPIRIO_AI_MIGRATION } from '../constants/FrontEndConstant';
import { LANGUAGE_CODE } from '../constants/DotEnv';

/**
 * Runtime switch for the empirio.ai migration. The placeholder is replaced by
 * the container entrypoint; an unreplaced or invalid value fails closed.
 */
const surveyCreationDisabledValue = '__REACT_APP_SURVEY_CREATION_DISABLED__'.toLowerCase();
export const SURVEY_CREATION_DISABLED = surveyCreationDisabledValue !== 'false';

/**
 * Popup shown instead of the survey creation flow.
 * Creating new surveys is disabled, users are pointed to empirio.ai.
 * No dismiss flag in localStorage - this has to show up on every attempt.
 */
export const showSurveyCreationDisabledPopup = (onCloseCallback) => {
    confirmAlert({
        // fires on every close path (button, click outside, escape)
        afterClose: () => {
            if (typeof onCloseCallback === 'function') {
                onCloseCallback();
            }
        },
        customUI: ({ onClose }) => {
            const handleClose = () => {
                onClose();
            };

            return (
                <div className='custom-ui empirio-ai-popup'>
                    <div className="close-btn text-right">
                        <button
                            className="d-inline-block bg-white border-0 w-auto text-rgb"
                            onClick={handleClose}
                        >
                            <i className="ti-close pointer"></i>
                        </button>
                    </div>
                    <div className="empirio-ai-popup-icon text-center mb-3">
                        <i className="fas fa-rocket fa-3x" style={{ color: '#00b3f4' }}></i>
                    </div>
                    <h3 className="mt-3 mb-3 font-weight-bold">{EMPIRIO_AI_MIGRATION[LANGUAGE_CODE]['creation_disabled_title']}</h3>
                    <p className="mb-3">{EMPIRIO_AI_MIGRATION[LANGUAGE_CODE]['creation_disabled_text']}</p>
                    <p className="mb-4">{EMPIRIO_AI_MIGRATION[LANGUAGE_CODE]['creation_disabled_hint']}</p>
                    <div className="d-flex justify-content-center align-items-center">
                        <a
                            href="https://www.empirio.ai"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-clr text-white mr-2"
                            onClick={handleClose}
                        >
                            {EMPIRIO_AI_MIGRATION[LANGUAGE_CODE]['creation_disabled_cta']}
                        </a>
                        <button
                            onClick={handleClose}
                            className="btn btn-secondary"
                        >
                            {EMPIRIO_AI_MIGRATION[LANGUAGE_CODE]['popup_close_button']}
                        </button>
                    </div>
                </div>
            );
        }
    });
};
